import { useEffect } from "react";

import { isDueSoon, isInLateSubmissionWindow } from "components/materials/page/helpers";
import { PageType } from "components/server-types";
import { useViewLevel } from "utils/urls";

export const MAX_SECTION_ITEMS_PER_SECTION = 5;
export const MAX_HOME_ITEMS_PER_SECTION = 3;

type CountHandler = (count: number) => void;
export type PageLimitProps = {
  showAll: boolean;
  onCountChanged: CountHandler;
};

export const getMaxItemsPerSection = (isHome: boolean) =>
  isHome ? MAX_HOME_ITEMS_PER_SECTION : MAX_SECTION_ITEMS_PER_SECTION;

export const usePageLimits = <T>(pages: T[], showAll: boolean, onCountChanged: CountHandler) => {
  const isHome = useViewLevel().home === true;
  const limitedPages = showAll ? pages : pages.slice(0, getMaxItemsPerSection(isHome));

  useEffect(() => {
    if (onCountChanged) {
      onCountChanged(pages.length);
    }
  }, [pages.length, onCountChanged]);

  return limitedPages;
};

export const filterOutPagesInOtherSections = <
  T extends Pick<PageType, "due_at" | "late_submission_interval">,
>(
  pages: T[],
) => pages.filter((page) => !isDueSoon(page) && !isInLateSubmissionWindow(page));
